/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PersonsPreviewSelector_persons$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type AssignSkillsToPersonsModal_company$ref: FragmentReference;
declare export opaque type AssignSkillsToPersonsModal_company$fragmentType: AssignSkillsToPersonsModal_company$ref;
export type AssignSkillsToPersonsModal_company = {|
  +id: string,
  +allPersons: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +$fragmentRefs: PersonsPreviewSelector_persons$ref
      |}
    |}>
  |},
  +$refType: AssignSkillsToPersonsModal_company$ref,
|};
export type AssignSkillsToPersonsModal_company$data = AssignSkillsToPersonsModal_company;
export type AssignSkillsToPersonsModal_company$key = {
  +$data?: AssignSkillsToPersonsModal_company$data,
  +$fragmentRefs: AssignSkillsToPersonsModal_company$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssignSkillsToPersonsModal_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "excludeClientUsers",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 10000
        }
      ],
      "concreteType": "PersonTypeConnection",
      "kind": "LinkedField",
      "name": "allPersons",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PersonTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PersonsPreviewSelector_persons"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "allPersons(excludeClientUsers:true,first:10000)"
    }
  ],
  "type": "Company"
};
// prettier-ignore
(node/*: any*/).hash = '4fdd53819fd8302c6fa800a96433ea95';

module.exports = node;
